import React from 'react';

export const EndAlignedContainer: React.FC = ({ children }) => (
  <div className="flex md:justify-end md:text-right">
    <div className="flex md:justify-end flex-wrap flex-col space-y-2 md:flex-row md:space-y-0 md:space-x-8">
      {children}
    </div>
  </div>
);
